(() => {
  'use strict';
  if (window.avCapriGift) return;
  const WATCH_PRODUCT = '7787337678935', WATCH_VARIANT = '44321164722263';
  const GIFT_PRODUCT = '7615501664343';
  const GIFT_HANDLE = 'delicate-tennis-bracelet-2mm-with-white-round-stone-on-white-gold';
  const GIFT_VARIANTS = new Set(['42661816303703','42661816336471','42661816369239','42661816402007','42661816434775','42661816467543','42661816500311','42673582964823']);
  const SIZE_PROPERTY = '_av_capri_gift_variant', GIFT_PROPERTY = '_av_capri_gift';
  const route = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartUrl = route + 'cart';
  let queue = Promise.resolve(), pendingAdd = null;
  const watchKeys = new Map();
  const serial = task => { const next = queue.then(task, task); queue = next.catch(() => {}); return next; };
  const properties = item => item.properties || {};
  const isWatch = item => String(item.product_id) === WATCH_PRODUCT && String(item.variant_id) === WATCH_VARIANT && !item.selling_plan_allocation;
  const isManaged = item => String(item.product_id) === GIFT_PRODUCT && GIFT_VARIANTS.has(String(item.variant_id)) && Object.hasOwn(properties(item), GIFT_PROPERTY);
  const isRelevant = cart => Array.isArray(cart?.items) && cart.items.some(item => isWatch(item) || isManaged(item));
  const propertyKey = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
  const quantityFor = (cart, props) => cart.items.filter(item => isWatch(item) && propertyKey(properties(item)) === propertyKey(props)).reduce((sum, item) => sum + item.quantity, 0);
  function problem(message, extra = {}) { return Object.assign(new Error(message), extra); }
  async function request(url, body) {
    let response;
    try {
      response = await fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', ...(body ? {'Content-Type':'application/json'} : {}) },
        ...(body ? {body:JSON.stringify(body)} : {}), signal: AbortSignal.timeout(20000) });
    } catch (_) { throw problem('We could not confirm the cart update. Check your bag before trying again.', {uncertain:true}); }
    const data = await response.json().catch(() => null);
    if (!response.ok) throw problem(typeof data?.description === 'string' ? data.description : 'Your cart could not be updated. Please try again.', {status:response.status});
    if (!data || typeof data !== 'object') throw problem('We could not confirm the cart update. Check your bag before trying again.', {uncertain:true});
    return data;
  }
  async function getCart() {
    const cart = await request(cartUrl + '.js');
    if (!Array.isArray(cart.items)) throw problem('Your bag could not be checked. Please refresh before checkout.');
    for (const item of cart.items.filter(isWatch)) watchKeys.set(item.key, propertyKey(properties(item)));
    return cart;
  }
  async function availableGift(variant, state) {
    if (!GIFT_VARIANTS.has(String(variant))) throw problem('Please choose an available complimentary 2mm tennis bracelet size.');
    if (!state.catalog) state.catalog = await request(route + 'products/' + GIFT_HANDLE + '.js');
    const selected = String(state.catalog.id) === GIFT_PRODUCT && state.catalog.variants?.find(item => String(item.id) === String(variant));
    if (!selected?.available) throw problem('Your selected complimentary bracelet size is unavailable. Choose or change the bracelet size in your bag before checkout.');
  }
  const parentKey = item => item.parent_relationship?.parent_key || null;
  function relevantState(cart) {
    return JSON.stringify(cart.items.filter(item => isWatch(item) || isManaged(item)).map(item => [item.key,item.quantity,properties(item),parentKey(item),item.final_line_price]));
  }
  function markCart(cart, changed) { Object.defineProperty(cart, 'avCapriGiftChanged', {value:changed, enumerable:false, configurable:true}); return cart; }

  // Re-plan from Shopify's latest keys after every write; discounts can change keys.
  // Only marked gifts are ever changed. A separately purchased bracelet stays intact.
  async function reconcileCart(state = {}) {
    let changed = false, previous = null;
    for (let attempt = 0; attempt < 32; attempt++) {
      const cart = await getCart();
      const current = relevantState(cart);
      if (previous === current) throw problem('The complimentary bracelet could not be updated. Please check availability before checkout.');
      const watches = cart.items.filter(isWatch), gifts = cart.items.filter(isManaged);
      let action;
      for (const gift of gifts) {
        const parent = watches.find(item => item.key === parentKey(gift));
        if (!parent || properties(parent)[SIZE_PROPERTY] !== String(gift.variant_id) || gift.selling_plan_allocation) {
          action = {kind:'change', id:gift.key, quantity:0}; break;
        }
      }
      if (!action) for (const watch of watches) {
        const variant = String(properties(watch)[SIZE_PROPERTY] || '');
        if (!GIFT_VARIANTS.has(variant)) throw problem('Choose or change the complimentary bracelet size in your bag before checkout.');
        const children = gifts.filter(item => parentKey(item) === watch.key && String(item.variant_id) === variant);
        const quantity = children.reduce((sum, item) => sum + item.quantity, 0);
        if (quantity > watch.quantity) {
          const child = children[children.length - 1];
          action = {kind:'change', id:child.key, quantity:Math.max(0, child.quantity - (quantity - watch.quantity))}; break;
        }
        if (quantity < watch.quantity) {
          await availableGift(variant, state);
          action = children.length
            ? {kind:'change', id:children[0].key, quantity:children[0].quantity + watch.quantity - quantity}
            : {kind:'add', item:{id:Number(variant), quantity:watch.quantity - quantity, parent_line_key:watch.key, properties:{[GIFT_PROPERTY]:'1'}}};
          break;
        }
      }
      if (!action) {
        const charged = gifts.filter(item => !Number.isSafeInteger(item.final_line_price) || item.final_line_price !== 0);
        if (charged.length) {
          // Never leave our automatically added bracelet charging the customer.
          // The next explicit attempt may repair the gift after the discount recovers.
          await request(cartUrl + '/update.js', {updates:Object.fromEntries(charged.map(item => [item.key,0]))});
          throw problem('Your complimentary bracelet discount could not be confirmed. The charged gift was removed; please resolve the offer before checkout.');
        }
        return markCart(cart, changed);
      }
      previous = current;
      try {
        if (action.kind === 'add') await request(cartUrl + '/add.js', {items:[action.item]});
        else await request(cartUrl + '/change.js', {id:action.id, quantity:action.quantity});
      } catch (error) {
        if (error.status === 422) throw problem('Your complimentary bracelet could not be updated. Choose another size or reduce the watch quantity. ' + error.message, {cause:error});
        throw error;
      }
      changed = true;
    }
    throw problem('The complimentary bracelet needs further checking. Please refresh your bag before checkout.');
  }

  function watchInput(formData, giftVariantId) {
    const variant = String(formData.get('id') || ''), gift = String(giftVariantId || '');
    const quantityText = String(formData.get('quantity') || '1');
    if (variant !== WATCH_VARIANT || !GIFT_VARIANTS.has(gift) || !/^\d+$/.test(quantityText)) throw problem('Please choose your Capri watch and complimentary bracelet size.');
    const quantity = Number(quantityText);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 999 || formData.get('selling_plan')) throw problem('Please choose a valid Capri watch quantity.');
    const props = {};
    for (const [name,value] of formData.entries()) {
      const match = name.match(/^properties\[([^\]]+)\]$/);
      if (match) { if (typeof value !== 'string') throw problem('This Capri selection cannot be added automatically.'); props[match[1]] = value; }
    }
    props[SIZE_PROPERTY] = gift;
    delete props[GIFT_PROPERTY];
    return {id:Number(WATCH_VARIANT),quantity,properties:props};
  }
  async function recoverPending(watch) {
    if (!pendingAdd) return null;
    const cart = await getCart(), current = quantityFor(cart, pendingAdd.properties);
    if (current <= pendingAdd.beforeQuantity) throw problem('The previous watch addition is unconfirmed. Please check or refresh your bag before trying again.', {uncertain:true});
    const sameIntent = propertyKey(watch.properties) === propertyKey(pendingAdd.properties) && watch.quantity === pendingAdd.requestedQuantity;
    let verified;
    try { verified = await reconcileCart(); }
    catch (error) { throw problem('Your watch is already in your bag. Choose or change the bracelet size in your bag. ' + error.message, {watchAdded:true}); }
    pendingAdd = null;
    return sameIntent ? verified : null;
  }
  function add(formData, giftVariantId) {
    // Snapshot the form immediately so a queued operation cannot read a later size.
    let watch;
    try { watch = watchInput(formData, giftVariantId); } catch (error) { return Promise.reject(error); }
    return serial(async () => {
      const recovered = await recoverPending(watch); if (recovered) return recovered;
      const state = {};
      await availableGift(watch.properties[SIZE_PROPERTY], state);
      const before = await getCart();
      const beforeQuantity = quantityFor(before, watch.properties), expectedQuantity = beforeQuantity + watch.quantity;
      pendingAdd = {properties:watch.properties,beforeQuantity,requestedQuantity:watch.quantity};
      let mutationError;
      try {
        // parent_id is unambiguous only when this parent variant is not already in
        // the cart. Otherwise add the watch first and use fresh parent_line_key.
        const existing = before.items.some(item => String(item.variant_id) === WATCH_VARIANT);
        const items = existing ? [watch] : [watch,{id:Number(watch.properties[SIZE_PROPERTY]),quantity:watch.quantity,parent_id:Number(WATCH_VARIANT),properties:{[GIFT_PROPERTY]:'1'}}];
        await request(cartUrl + '/add.js', {items});
      } catch (error) { mutationError = error; }
      let after;
      try { after = await getCart(); }
      catch (error) { throw problem('Your watch addition could not be confirmed. Please check your bag before trying again.', {uncertain:true,cause:error}); }
      const actualQuantity = quantityFor(after, watch.properties);
      if (actualQuantity <= beforeQuantity) {
        if (mutationError?.status && !mutationError.uncertain) pendingAdd = null;
        throw mutationError || problem('Your watch addition could not be confirmed. Please check your bag before trying again.', {uncertain:true});
      }
      try {
        const verified = await reconcileCart(state);
        if (actualQuantity < expectedQuantity) throw problem('Only the available watch quantity was added. Please check your bag before adding more.', {watchAdded:true});
        pendingAdd = null;
        return verified;
      } catch (error) {
        throw problem('Your watch is in your bag. ' + error.message, {watchAdded:true,cause:error});
      }
    });
  }
  function setSize(watchKey, giftVariantId) {
    return serial(async () => {
      const variant = String(giftVariantId || ''), state = {};
      await availableGift(variant, state);
      const cart = await getCart();
      let watch = cart.items.find(item => item.key === watchKey && isWatch(item));
      if (!watch && watchKeys.has(watchKey)) {
        const matches = cart.items.filter(item => isWatch(item) && propertyKey(properties(item)) === watchKeys.get(watchKey));
        if (matches.length === 1) watch = matches[0];
      }
      if (!watch) throw problem('The watch line has changed. Please refresh your bag before choosing its bracelet size.');
      if (String(properties(watch)[SIZE_PROPERTY] || '') !== variant) {
        // Shopify can revalidate the old nested size's inventory when changing
        // its parent. Remove only our children before choosing the replacement,
        // so an exhausted old size cannot prevent moving to an available size.
        const children = cart.items.filter(item => isManaged(item) && parentKey(item) === watch.key);
        if (children.length) {
          const previousKey = watch.key, previousProperties = propertyKey(properties(watch));
          await request(cartUrl + '/update.js', {updates:Object.fromEntries(children.map(item => [item.key,0]))});
          const fresh = await getCart();
          watch = fresh.items.find(item => item.key === previousKey && isWatch(item));
          if (!watch) {
            const matches = fresh.items.filter(item => isWatch(item) && propertyKey(properties(item)) === previousProperties);
            if (matches.length === 1) watch = matches[0];
          }
          if (!watch) throw problem('The watch line has changed. Please refresh your bag before choosing its bracelet size.');
        }
      }
      await request(cartUrl + '/change.js', {id:watch.key,quantity:watch.quantity,properties:{...properties(watch),[SIZE_PROPERTY]:variant}});
      const verified = await reconcileCart(state);
      pendingAdd = null;
      return markCart(verified, true);
    });
  }
  window.avCapriGift = Object.freeze({add,setSize,reconcile:() => serial(() => reconcileCart()),isRelevant,isManaged});
})();
